import { useTranslate } from '@above-the-treeline/localization';

export function withLocalize(WrappedComponent) {
	return function LocalizeComponent(props) {
		const { translate } = useTranslate();
		return <WrappedComponent translate={translate} {...props} />;
	};
}
